import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="job-work-place"
export default class extends Controller {
  static targets = ["noneOption", "otherOption"];

  declare readonly noneOptionTarget: HTMLInputElement;
  declare readonly otherOptionTargets: HTMLInputElement[];
  declare boundNoneOptionChangeHandler: (event: Event) => void;
  declare boundOtherOptionChangeHandler: (event: Event) => void;

  connect() {
    // 初期状態の設定
    this.updateDisabledState();

    // イベントリスナーを設定
    this.boundNoneOptionChangeHandler = this.onNoneOptionChange.bind(this);
    this.boundOtherOptionChangeHandler = this.onOtherOptionChange.bind(this);

    this.noneOptionTarget.addEventListener("change", this.boundNoneOptionChangeHandler);
    this.otherOptionTargets.forEach((option) => {
      option.addEventListener("change", this.boundOtherOptionChangeHandler);
    });
  }

  disconnect() {
    // イベントリスナーをクリーンアップ
    this.noneOptionTarget.removeEventListener("change", this.boundNoneOptionChangeHandler);
    this.otherOptionTargets.forEach((option) => {
      option.removeEventListener("change", this.boundOtherOptionChangeHandler);
    });
  }

  // 希望なしオプションの変更時
  onNoneOptionChange() {
    this.updateDisabledState();
  }

  // 他のオプションの変更時
  onOtherOptionChange() {
    // いずれかの他のオプションがチェックされていれば「希望なし」をオフにする
    const anyOtherChecked = this.otherOptionTargets.some((option) => option.checked);
    if (anyOtherChecked && this.noneOptionTarget.checked) {
      this.noneOptionTarget.checked = false;
    }
  }

  // 状態を更新する処理
  updateDisabledState() {
    const isNoneOptionChecked = this.noneOptionTarget.checked;

    this.otherOptionTargets.forEach((option) => {
      // 希望なしがチェックされていたら他のオプションをクリアして無効化
      option.disabled = isNoneOptionChecked;
      if (isNoneOptionChecked) {
        option.checked = false;
      }
    });
  }
}
